export default "__VITE_ASSET__B1AVv6FO__"